
import { computed, defineComponent, ref } from "vue";
import SampleTemplatesRepository from "~/repositories/SampleTemplatesRepository";
import SampleTemplateModel from "~/models/SampleTemplateModel";

export default defineComponent({
  name: "SampleContentModal",
  props: {
    contentName: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const isShowModal = ref(false);

    const sampleTemplate = ref<SampleTemplateModel>(new SampleTemplateModel());
    const setEmptyTemplate = () => {
      sampleTemplate.value = new SampleTemplateModel();
    };
    const getTemplate = async () => {
      setEmptyTemplate();
      try {
        const repository = new SampleTemplatesRepository();
        const template = await repository.index({ content: props.contentName });
        sampleTemplate.value = template;
      } catch (e) {
        alert("プレビュー本文の取得に失敗しました。再度お試しください。");
      }
    };

    const toggleModal = () => {
      if (isShowModal.value) {
        setEmptyTemplate();
      } else {
        getTemplate();
      }

      isShowModal.value = !isShowModal.value;
    };

    const downloadUrl = computed(() => {
      return `/static/material/samples/${props.contentName}`;
    });

    const createArticleUrl = computed(() => {
      return `/users/articles/new?template=${props.contentName}`;
    });

    return {
      isShowModal,
      sampleTemplate,
      downloadUrl,
      createArticleUrl,
      toggleModal
    };
  }
});
